import { QueryPartData } from '../../../advanced-search/filters/base/entities/query-part-data.entity';
import { QueryPartStrategy } from '../../../advanced-search/filters/base/entities/query-part-strategy';
import { QueryPart } from '../../../advanced-search/filters/base/entities/query-part.class';
import { StructuredQueryToQueryParts } from '../helpers/structured-query.helper';
import { LogicalOperand, Operand } from './operand.entity';

export interface StructuredQuery {
    Global: string[]; // q
    Semantic: string; // sq
    FullText: string; // ftq
    AdvancedSearch: AdvancedSearch; // advQ
    Facets: Facet[]; // f
    Fields: QueryPartData[]; // fields
    ColumnFilters: QueryPartData[]; // cf
    Predefined?: string[]; // Background/prefilter queries
}
export interface ApiStructuredQuery {
    Global: string[];
    Semantic: string;
    FullText: string;
    AdvancedSearch?: AdvancedSearch;
    Facets: Facet[];
    Predefined: string[];
}

export interface AdvancedSearch {
    LogicalOperand: LogicalOperand;
    Groups: AdvancedSearchGroup[];
}

export interface AdvancedSearchGroup {
    LogicalOperand: LogicalOperand;
    Terms?: AdvancedSearchTerm[];
}

export interface AdvancedSearchTerm {
    DottedKey: string;
    Operand: Operand;
    Values?: string[];
    RangeValues?: RangeValue[];
}

export interface RangeValue {
    Begin: string;
    End: string;
    IncludeBegin: boolean;
    IncludeEnd: boolean;
    Gap?: string;
}

export interface Facet {
    LogicalOperand: LogicalOperand;
    DottedKey: string;
    Buckets?: Bucket[];
    RangeBuckets?: RangeBucket[];
}

export interface Bucket {
    Operand: Operand;
    Value: string;
}

export interface RangeBucket {
    Operand: Operand;
    RangeValue: RangeValue;
}

export function OperandToQueryPartStrategy(operand: Operand): QueryPartStrategy {
    switch (operand) {
        case Operand.Include:
            return QueryPartStrategy.MatchAll;
        case Operand.Exclude:
            return QueryPartStrategy.MatchNone;
        case Operand.Should:
            return QueryPartStrategy.MatchAtLeastOne;
        default:
            console.warn('Unknown operand. Returning MatchAll.');
            return QueryPartStrategy.MatchAll;
    }
}

export function QueryPartStrategyToOperand(queryPartStrategy: QueryPartStrategy): Operand {
    switch (queryPartStrategy) {
        case QueryPartStrategy.MatchAll:
            return Operand.Include;
        case QueryPartStrategy.MatchNone:
            return Operand.Exclude;
        case QueryPartStrategy.MatchAtLeastOne:
            return Operand.Should;
        default:
            console.warn('Unknown QueryPartStrategy. Returning Include.');
            return Operand.Include;
    }
}

export function getSearchValues(query: StructuredQuery, field: string, operand = Operand.Include): string[] {
    const queryParts: QueryPart[] = StructuredQueryToQueryParts(query);

    const strategy: QueryPartStrategy = OperandToQueryPartStrategy(operand);

    const terms: string[] = queryParts
        .filter(qp => qp.field === field && qp.strategy === strategy)
        .flatMap(qp => qp.values);

    return terms;
}
